/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_activity_activitytypes_discussion1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토론`)
};

const en_activity_activitytypes_discussion1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion`)
};

const ja_activity_activitytypes_discussion1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディスカッション`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const activity_activitytypes_discussion1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.activity_activitytypes_discussion1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("activity_activitytypes_discussion1", locale)
	if (locale === "ko") return ko_activity_activitytypes_discussion1(inputs)
	if (locale === "en") return en_activity_activitytypes_discussion1(inputs)
	return ja_activity_activitytypes_discussion1(inputs)
};
export { activity_activitytypes_discussion1 as "activity_activityTypes_discussion" }